import { render, staticRenderFns } from "./WidgetWinner.vue?vue&type=template&id=062c443e&scoped=true"
import script from "./WidgetWinner.vue?vue&type=script&lang=js"
export * from "./WidgetWinner.vue?vue&type=script&lang=js"
import style0 from "./WidgetWinner.vue?vue&type=style&index=0&id=062c443e&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c443e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062c443e')) {
      api.createRecord('062c443e', component.options)
    } else {
      api.reload('062c443e', component.options)
    }
    module.hot.accept("./WidgetWinner.vue?vue&type=template&id=062c443e&scoped=true", function () {
      api.rerender('062c443e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/games/WidgetWinner.vue"
export default component.exports